import React, { Component } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import ListPanel from '../../ListPanel/ListPanel';
import './SurveyJobMatchesList.scss';

class SurveyJobMatchesList extends Component {
  static propTypes = {
    onSurveyJobClick: func,
    selectAllSurveyJobMatches: func,
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      descriptionDocument: shape({
        fileLocation: string,
        title: string
      }),
      employeeCount: number,
      id: string,
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    showSurveyJobDescription: bool
  };

  render() {
    const {
      onSurveyJobClick,
      selectAllSurveyJobMatches,
      selectedJob,
      selectedSurveyJobs,
      showSurveyJobDescription
    } = this.props;

    return (
      <ListPanel
        data={selectedJob.jobMatches}
        onClick={onSurveyJobClick}
        selectAll={selectAllSurveyJobMatches}
        selectedItems={selectedSurveyJobs}
        showSurveyJobDescription={showSurveyJobDescription}
      />
    );
  }
}

export default SurveyJobMatchesList;
